import { frontendURL } from 'dashboard/helper/URLHelper.js';
import TemplatesPageRouteView from './pages/TemplatesPageRouteView.vue';
import TemplatesListPage from './pages/TemplatesListPage.vue';
import TemplateBuilderPage from './pages/TemplateBuilderPage.vue';

const meta = {
  permissions: ['administrator', 'agent'],
};

const metaAdmin = {
  permissions: ['administrator'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/meta-templates'),
    component: TemplatesPageRouteView,
    children: [
      {
        path: '',
        name: 'whatsapp_templates_index',
        meta,
        component: TemplatesListPage,
      },
      {
        path: 'new',
        name: 'whatsapp_templates_new',
        meta: metaAdmin,
        component: TemplateBuilderPage,
      },
    ],
  },
];
